import React from "react";

const WorkOrderStep1BasicInfo = ({
  formData,
  setFormData,
  formErrors,
  workOrderTypes,
  priorities,
  statuses,
}) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title fnt20">Basic Information</h3>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="workOrderNumber">Work Order Number</label>
            <input
              type="text"
              id="workOrderNumber"
              name="workOrderNumber"
              value={formData.workOrderNumber}
              onChange={handleChange}
              placeholder="Auto-generated if left empty"
            />
          </div>
          <div className="form-group">
            <label htmlFor="statusId">
              Status <span className="required">*</span>
            </label>
            <select
              id="statusId"
              name="statusId"
              value={formData.statusId}
              onChange={handleChange}
              className={formErrors.statusId ? "error" : ""}
            >
              <option value="">Select Status</option>
              {statuses.map((status) => (
                <option key={status.statusId} value={status.statusId}>
                  {status.statusName}
                </option>
              ))}
            </select>
            {formErrors.statusId && (
              <span className="field-error">{formErrors.statusId}</span>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="workTypeId">
              Work Type <span className="required">*</span>
            </label>
            <select
              id="workTypeId"
              name="workTypeId"
              value={formData.workTypeId}
              onChange={handleChange}
              className={formErrors.workTypeId ? "error" : ""}
            >
              <option value="">Select Work Type</option>
              {workOrderTypes.map((type) => (
                <option key={type.typeId} value={type.typeId}>
                  {type.typeName}
                </option>
              ))}
            </select>
            {formErrors.workTypeId && (
              <span className="field-error">{formErrors.workTypeId}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="priorityId">
              Priority <span className="required">*</span>
            </label>
            <select
              id="priorityId"
              name="priorityId"
              value={formData.priorityId}
              onChange={handleChange}
              className={formErrors.priorityId ? "error" : ""}
            >
              <option value="">Select Priority</option>
              {priorities.map((priority) => (
                <option key={priority.priorityId} value={priority.priorityId}>
                  {priority.priorityName}
                </option>
              ))}
            </select>
            {formErrors.priorityId && (
              <span className="field-error">{formErrors.priorityId}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep1BasicInfo;
